module.exports = __webpack_public_path__ + "static/media/a12.5fba0408.jpg";